import { BaseService, RequestType } from "@intech/react-service";
import { ProcessoBeneficioEntidade } from "../entidades";

class ProcessoBeneficio extends BaseService {

  constructor() {
    super("processoBeneficio");
  }

  BuscarPorPlano = (plano: string) =>
    this.CreateRequest<Array<ProcessoBeneficioEntidade>>(RequestType.GET, `porPlano/${plano}`);

}

export const ProcessoBeneficioService = new ProcessoBeneficio();